
import { useEffect, useState } from "react";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import { twMerge } from "tailwind-merge";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import { SetWalletTransAtom,GetWalletTransAtom} from "../../store/walletTransAtom";
import { formatCustomDate } from "../../helpers/formatCustomDate";
import { walletTransService } from "../../services/walletTransService";



function WalletTransScroll() {
   const walletAtomList = GetWalletTransAtom();
   const setWalletTransAtom = SetWalletTransAtom();
  const navigate = useNavigate();
  const {  id } = useParams();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];




   useEffect(() => {
      document.title = "Wallet Transactions"
  
      if(!walletAtomList?.wallet_transaction?.length){
         getWalletListApi();
  
      }
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [walletAtomList?.wallet_transaction?.length]);



    const getWalletListApi = async () => {
      try {
        const response = await walletTransService.walletTransList();
        if (response?.data?.transaction_type?.length) {
          setWalletTransAtom(response.data);
      
        }
      } catch (error) {
        console.log("QUERY FAILED");
      }
    };
  



  function viewItemDetails(id) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }


  const manageInvoiceStatus = (status) => {
    let defaultClass = "text-primary";

    switch (status) {
      case "Draft":
        defaultClass = "text-danger";
        break;
      case "Approved":
        defaultClass = "text-success";
        break;
      case "Void":
        defaultClass = "text-warning";
        break;
      case "Pending Approval":
        defaultClass = "text-info";
        break;

      default:
        break;
    }

    return (
      <span className={`text-sm font-medium ${defaultClass} `}>{status}</span>
    );
  };

  return (
    <>
        {/* <CreditNoteFilter
            bulkActionData={creditNoteAtom?.status_info}
            onFilterSelect={onFilterSelect}
          /> */}
      <section className="border-[1px] rounded-lg bg-white border-gray-200 flex flex-col overflow-y-scroll h-[300px] lg:h-[500px] scrollbar-thumb-gray-500 scrollbar-thin scrollbar-track-gray-100 pb-[100px]">
        <div className="border-b-[1px] border-b-gray-300">
      
        </div>
        {walletAtomList?.wallet_transaction.map((walletTrans, i) => {
          return (
            <div key={i}
              className={`p-2 lg:p-1 grid grid-cols-2 lg:grid-cols-none  border-b-[1px] cursor-pointer border-gray-200 ${
                id == walletTrans?.ref_no
                  ? "bg-gray-200"
                  : "hover:bg-gray-100"
              }`}
            >
              <div className="flex flex-row">
                <div className="">
                  {/* <input
                    onChange={(e) => onCheckAll(e, i)}
                    checked={note?.checked ? note?.checked : ""}
                    type="checkbox"
                    className="w-4 h-4 border-[1px] border-gray-300 rounded-sm cursor-pointer"
                  /> */}
                </div>

                <div
                  onClick={() => viewItemDetails(walletTrans.ref_no)}
                  className="ml-1"
                >
                  <div className="text-sm font-bold text-gray-700">
                    {walletTrans?.ref_no}
                  </div>
                  {/* <div className="text-xs text-gray-400 font-semibold italic">
                    {note?.Invoice_Ref_No}
                  </div> */}
                  <div className="text-sm lg:text-xs text-gray-600">
                    {formatCustomDate(walletTrans?.transaction_date)}
                  </div>
                </div>
              </div>
              <div
                onClick={() => viewItemDetails(walletTrans.ref_no)}
                className="lg:mt-2 lg:ml-5 "
              >
                <div className={twMerge("text-sm font-normal")}>
                  {manageInvoiceStatus(walletTrans?.customer_full_name)}
                </div>

                <div className="mt-[2px] text-sm lg:text-xs font-bold text-gray-700">
                  <CurrencyFormat
                    value={parseFloat(walletTrans?.amount)?.toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"₦"}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </section>
    </>
  );
}

export default WalletTransScroll;
